<fieldset class="fieldset fieldset-select-date">

  <form class="form-group" [formGroup]="parent">
    <div class="desktop-tooltip">
    <div *ngIf="question.questionText" class="question-style normal-ques-style mt-30">
      <span> {{question.questionText}} </span>

    </div>
    <div class="info-icon d-view" *ngIf="question.helpText">
      <app-tool-tip-notification [uwQuesForWA]="question" (lifestyleInfoEmitter)="lifestyleInfoReceiver($event)" 
      *ngIf="question.helpText" [childId]="'dateComp'" [tooltipData]="initializeToolTipDateComp(question)">
      </app-tool-tip-notification>
    </div>
    <div class="info-icon mt-view" *ngIf="question.helpText">
      <app-tool-tip-notification [uwQuesForWA]="question" (lifestyleInfoEmitter)="lifestyleInfoReceiver($event)"
       *ngIf="question.helpText" [childId]="'dateComp'" [tooltipData]="initializeToolTipDateComp(question)" 
       (onDisplayMobileTooltipEmitter)="displayDrpTooltipMessage(question)">
      </app-tool-tip-notification>
    </div>
      <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeModal()"
      (primaryBtnClick)="alertTooltipPrimaryBtnClick()" (secondaryBtnClick)="alertSecondaryBtnClick()" [tooltipFlag]="true"></app-modal>
    </div>
    <div class="col-md-12 calender-container">
      <div class="form-field">
        <label for="select-id-2" class="form-label access">Month</label>

        <div class="form-field-select">
          <select [ngClass]="{'invalid-error-border': (parent.get(controlNameForMonth).touched && parent.get(controlNameForMonth).errors)}"
            class="form-control" id="{{domId+ '-Month'}}" aria-invalid="false" aria-labelledby="legend-select-date" [(ngModel)]="selectedMonth"
            (change)="onChangeOfDropdown($event)" [formControlName]="controlNameForMonth">
            <option value="">Month</option>
            <option *ngFor="let month of Months" [ngValue]="month.value">
              {{month.key}}</option>
          </select>
          <i class="icon icon-chevron-down" aria-hidden="true"></i>
        </div>
      </div>

      <div class="form-field">
        <label for="select-id-3" class="form-label access">Year</label>

        <div class="form-field-select">
          <select [ngClass]="{'invalid-error-border': (parent.get(controlNameForYear).touched && parent.get(controlNameForYear).errors)}"
            class="form-control" id="{{domId+ '-Year'}}" aria-invalid="false" aria-labelledby="legend-select-date" [(ngModel)]="selectedYear"
            (change)="onChangeOfDropdown($event)" [formControlName]="controlNameForYear">
            <option value="">Year </option>
            <option *ngFor="let year of Years" [ngValue]="year">
              {{year}}</option>
          </select>

          <i class="icon icon-chevron-down" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </form>
</fieldset>

<!-- <p>
  parent.get(controlNameForMonth).touched-> {{parent.get(controlNameForMonth).touched}}
  parent.get(controlNameForMonth).errors-> {{parent.get(controlNameForMonth).errors}}
</p> -->

<div class="top-10 form-validation-error" *ngIf="(parent.get(controlNameForMonth).touched && parent.get(controlNameForMonth).errors) 
      || (parent.get(controlNameForYear).touched && parent.get(controlNameForYear).errors)">

  <i class="icon icon-error" aria-hidden="true"></i>

  <p [id]="pageName+'-'+controlName +'-error'" *ngIf="((parent.get(controlNameForMonth).errors 
        && parent.get(controlNameForMonth).errors.required) || (parent.get(controlNameForYear).errors 
        && parent.get(controlNameForYear).errors.required))" aria-hidden="false" role="error" aria-live="polite">
    Please make a selection</p>

  <p [id]="pageName+'-'+controlName +'-error'" *ngIf="(isMonthAndYearBothSelected()) && ((parent.get(controlNameForMonth).errors 
        && parent.get(controlNameForMonth).errors.notValid) || (parent.get(controlNameForYear).errors 
        && parent.get(controlNameForYear).errors.notValid))" aria-hidden="false" role="error" aria-live="polite">
    Please select a valid date</p>

  <p [id]="pageName+'-'+controlName +'-error'" *ngIf="(isMonthAndYearBothSelected()) && ((parent.get(controlNameForYear).errors 
        && parent.get(controlNameForYear).errors.startDateInvalid))" aria-hidden="false" role="error" aria-live="polite">
    Please select a valid date</p>

  <p [id]="pageName+'-'+controlName +'-error'" *ngIf="(isMonthAndYearBothSelected()) &&  ((parent.get(controlNameForMonth).errors 
        && parent.get(controlNameForMonth).errors.futureDateInvalid) || (parent.get(controlNameForYear).errors 
        && parent.get(controlNameForYear).errors.futureDateInvalid))" aria-hidden="false" role="error" aria-live="polite">
    Please select a valid date</p>
</div>